import { Component, OnInit, OnDestroy, NgZone, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';

// Services
import { ImageService } from '@core/services/image.service';

/**
 * Page d'authentification — habillage uniquement : rotation des fonds d'écran autour du
 * `<router-outlet>`. Les composants enfants (`AppLogin`, `AppRegister`) sont montés selon l'URL :
 * `/login` → `AppLogin`, `/register` → `AppRegister`.
 */
@Component({
	selector: 'page-auth',
	imports: [RouterOutlet],
	templateUrl: './auth.html',
	styleUrl: './auth.scss',
})
export class AuthPage implements OnInit, OnDestroy {
	backgrounds: string[] = [];
	currentBackgroundIndex = signal(0);
	previousBackgroundIndex = signal(-1);
	private intervalId?: ReturnType<typeof setInterval>;

	constructor(
		private imageService: ImageService,
		private ngZone: NgZone,
	) {}

	ngOnInit(): void {
		this.backgrounds = this.imageService.getBackgrounds();
		if (this.backgrounds.length > 1) {
			this.startBackgroundRotation();
		}

		if (!sessionStorage.getItem('loginReloaded')) {
			sessionStorage.setItem('loginReloaded', 'true');
			window.location.reload();
		} else {
			sessionStorage.removeItem('loginReloaded');
		}
	}

	ngOnDestroy(): void {
		if (this.intervalId) {
			clearInterval(this.intervalId);
		}
	}

	private startBackgroundRotation(): void {
		this.ngZone.runOutsideAngular(() => {
			this.intervalId = setInterval(() => {
				this.ngZone.run(() => {
					this.previousBackgroundIndex.set(this.currentBackgroundIndex());
					this.currentBackgroundIndex.set((this.currentBackgroundIndex() + 1) % this.backgrounds.length);
				});
			}, 6000);
		});
	}

	isBackgroundVisible(index: number): boolean {
		return index === this.currentBackgroundIndex() || index === this.previousBackgroundIndex();
	}
}
